// // utils/socketManager.js
// import io from "socket.io-client";

// class SocketManager {
//   constructor() {
//     this.socket = null;
//     this.eventListeners = new Map();
//     this.isConnecting = false;
//   }

//   connect(options = {}) {
//     if (this.socket?.connected || this.isConnecting) {
//       return this.socket;
//     }

//     this.isConnecting = true;

//     const defaultOptions = {
//       transports: ["websocket"],
//       reconnection: true,
//       reconnectionAttempts: 10,
//       reconnectionDelay: 2000,
//       reconnectionDelayMax: 5000,
//       pingInterval: 10000,
//       pingTimeout: 20000,
//       closeOnBeforeunload: false,
//       secure: process.env.NODE_ENV === "production",
//       timeout: 10000,
//       forceNew: false,
//     };

//     this.socket = io(process.env.REACT_APP_SOCKET_URL, {
//       ...defaultOptions,
//       ...options,
//     });

//     this.setupEventHandlers();
//     this.isConnecting = false;

//     return this.socket;
//   }

//   setupEventHandlers() {
//     if (!this.socket) return;

//     this.socket.on("connect", () => {
//       console.log("Socket connected:", this.socket.id);
//       this.reattachListeners();
//     });

//     this.socket.on("disconnect", (reason) => {
//       console.log("Socket disconnected:", reason);
//       if (reason === "io server disconnect") {
//         setTimeout(() => this.socket?.connect(), 1000);
//       }
//     });

//     this.socket.on("reconnect", (attemptNumber) => {
//       console.log(`Socket reconnected after ${attemptNumber} attempts`);
//       this.reattachListeners();
//     });

//     this.socket.on("reconnect_attempt", (attempt) => {
//       console.log(`Reconnect attempt #${attempt}`);
//     });

//     this.socket.on("connect_error", (error) => {
//       console.error("Socket connection error:", error);
//     });
//   }

//   reattachListeners() {
//     // Reattach all registered listeners after reconnection
//     this.eventListeners.forEach((callbacks, eventName) => {
//       callbacks.forEach((callback) => {
//         this.socket?.off(eventName, callback);
//         this.socket?.on(eventName, callback);
//       });
//     });
//   }

//   on(eventName, callback) {
//     if (!this.socket) {
//       console.warn("Socket not initialized");
//       return;
//     }

//     if (!this.eventListeners.has(eventName)) {
//       this.eventListeners.set(eventName, new Set());
//     }

//     this.eventListeners.get(eventName).add(callback);
//     this.socket.on(eventName, callback);
//   }

//   off(eventName, callback) {
//     if (!this.socket) return;

//     this.socket.off(eventName, callback);

//     if (this.eventListeners.has(eventName)) {
//       this.eventListeners.get(eventName).delete(callback);
//       if (this.eventListeners.get(eventName).size === 0) {
//         this.eventListeners.delete(eventName);
//       }
//     }
//   }

//   emit(eventName, data, callback) {
//     if (!this.socket?.connected) {
//       console.warn(`Cannot emit ${eventName}: Socket not connected`);
//       return false;
//     }

//     if (callback) {
//       this.socket.emit(eventName, data, callback);
//     } else {
//       this.socket.emit(eventName, data);
//     }
//     return true;
//   }

//   disconnect() {
//     if (this.socket) {
//       // Clean up all listeners
//       this.eventListeners.clear();
//       this.socket.disconnect();
//       this.socket = null;
//     }
//   }

//   isConnected() {
//     return this.socket?.connected || false;
//   }

//   getSocketId() {
//     return this.socket?.id || null;
//   }
// }

// // Export singleton instance
// export const socketManager = new SocketManager();



// utils/socketManager.js

import io from "socket.io-client";

class SocketManager {
  constructor() {
    this.socket = null;
    this.eventListeners = new Map();
    this.isConnecting = false;
    this.isInitialized = false; // Prevent multiple initializations
  }

  connect(options = {}) {
    // Prevent multiple connections - return existing if already connected or connecting
    if (this.isInitialized && this.socket) {
      console.log("Socket already initialized, returning existing connection");
      return this.socket;
    }

    if (this.isConnecting) {
      console.log("Connection already in progress");
      return this.socket;
    }

    this.isConnecting = true;
    this.isInitialized = true;

    const defaultOptions = {
      transports: ["websocket", "polling"],
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 10000,
      pingInterval: 25000,
      pingTimeout: 60000,
      closeOnBeforeunload: false,
      secure: process.env.NODE_ENV === "production",
      timeout: 20000,
      forceNew: false, // IMPORTANT: Don't force new connections
      autoConnect: true,
      upgrade: true,
      rememberUpgrade: true,
    };

    console.log("Creating new socket connection...");
    this.socket = io(process.env.REACT_APP_SOCKET_URL, {
      ...defaultOptions,
      ...options,
    });

    this.setupEventHandlers();
    this.addVisibilityHandler();
    this.isConnecting = false;

    return this.socket;
  }

  setupEventHandlers() {
    if (!this.socket) return;

    this.socket.on("connect", () => {
      console.log("Socket connected with ID:", this.socket.id);
      this.reattachListeners();
    });

    this.socket.on("disconnect", (reason) => {
      console.log("Socket disconnected:", reason);
      // Don't reset isInitialized - keep the same socket instance
    });

    this.socket.on("reconnect", (attemptNumber) => {
      console.log(`Socket reconnected after ${attemptNumber} attempts. New ID:`, this.socket.id);
      this.reattachListeners();
    });

    this.socket.on("reconnect_attempt", (attempt) => {
      console.log(`Reconnect attempt #${attempt}`);
    });

    this.socket.on("connect_error", (error) => {
      console.error("Socket connection error:", error);
    });
  }

  reattachListeners() {
    // Reattach all registered listeners after reconnection
    this.eventListeners.forEach((callbacks, eventName) => {
      callbacks.forEach((callback) => {
        this.socket?.off(eventName, callback);
        this.socket?.on(eventName, callback);
      });
    });
  }

  on(eventName, callback) {
    if (!this.socket) {
      console.warn("Socket not initialized. Call connect() first.");
      return;
    }

    if (!this.eventListeners.has(eventName)) {
      this.eventListeners.set(eventName, new Set());
    }

    // Prevent duplicate listeners
    if (!this.eventListeners.get(eventName).has(callback)) {
      this.eventListeners.get(eventName).add(callback);
      this.socket.on(eventName, callback);
    }
  }

  off(eventName, callback) {
    if (!this.socket) return;

    this.socket.off(eventName, callback);

    if (this.eventListeners.has(eventName)) {
      this.eventListeners.get(eventName).delete(callback);
      if (this.eventListeners.get(eventName).size === 0) {
        this.eventListeners.delete(eventName);
      }
    }
  }

  emit(eventName, data, callback) {
    if (!this.socket?.connected) {
      console.warn(`Cannot emit ${eventName}: Socket not connected. Current ID:`, this.socket?.id);
      return false;
    }

    console.log(`Emitting ${eventName} on socket:`, this.socket.id);
    
    if (callback) {
      this.socket.emit(eventName, data, callback);
    } else {
      this.socket.emit(eventName, data);
    }
    return true;
  }

  disconnect() {
    if (this.socket) {
      console.log("Manually disconnecting socket:", this.socket.id);
      this.eventListeners.clear();
      this.removeVisibilityHandler();
      this.socket.disconnect();
      this.socket = null;
      this.isInitialized = false; // Reset for new connections
    }
  }

  isConnected() {
    return this.socket?.connected || false;
  }

  getSocketId() {
    return this.socket?.id || null;
  }

  // Modified visibility handler - don't create new connections
  addVisibilityHandler() {
    const handler = () => {
      if (document.visibilityState === "visible") {
        console.log("Tab is active. Current socket:", this.socket?.id, "Connected:", this.isConnected());
        
        // Only reconnect if socket exists but is disconnected
        if (this.socket && !this.isConnected()) {
          console.log("Reconnecting existing socket...");
          this.socket.connect();
        }
      }
    };
    document.addEventListener("visibilitychange", handler);
    this._visibilityHandler = handler;
  }

  removeVisibilityHandler() {
    if (this._visibilityHandler) {
      document.removeEventListener("visibilitychange", this._visibilityHandler);
      this._visibilityHandler = null;
    }
  }

  // Debug method to check current state
  getDebugInfo() {
    return {
      socketId: this.getSocketId(),
      connected: this.isConnected(),
      initialized: this.isInitialized,
      connecting: this.isConnecting,
      listeners: Array.from(this.eventListeners.keys())
    };
  }
}

// Export singleton instance
export const socketManager = new SocketManager();
